
<div *ngIf="lot">
    <h2><span jhiTranslate="inventoryManagerApp.lot.detail.title">Lot</span> {{lot.id}}</h2>
    <hr>
    <dl class="row-md jh-entity-details">
        <dt><span jhiTranslate="inventoryManagerApp.lot.userId">User Id</span></dt>
        <dd>
            <span>{{lot.userId}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.eType">E Type</span></dt>
        <dd>
            <span>{{lot.eType}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.eId">E Id</span></dt>
        <dd>
            <span>{{lot.eId}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.locId">Loc Id</span></dt>
        <dd>
            <span>{{lot.locId}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.unitId">Scale Id</span></dt>
        <dd>
            <span>{{lot.unitId}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.status">Status</span></dt>
        <dd>
            <span>{{lot.status}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.sourceId">Source Id</span></dt>
        <dd>
            <span>{{lot.sourceId}}</span>
        </dd>
        <dt><span jhiTranslate="inventoryManagerApp.lot.comments">Comments</span></dt>
        <dd>
            <span>{{lot.notes}}</span>
        </dd>
    </dl>

    <button type="submit"
            (click)="previousState()"
            class="btn btn-info">
        <span class="fa fa-arrow-left"></span>&nbsp;<span jhiTranslate="entity.action.back"> Back</span>
    </button>

    <button type="button"
            [routerLink]="['/', { outlets: { popup: 'lot/'+ lot.id + '/edit'} }]"
            replaceUrl="true"
            queryParamsHandling="merge"
            class="btn btn-primary">
        <span class="fa fa-pencil"></span>&nbsp;<span jhiTranslate="entity.action.edit"> Edit</span>
    </button>
</div>
